<template>
  <div
    class="vto-modal"
    :class="{ 'vto-closed': !modalDisplay }"
  >
    <div class="vto-app-wrapper">
      <dsf-app
        :tenant="tenant"
        :application="application"
        :customer="customer"
        :country="country"
        :environment="environment"
        :touchpoint="touchpoint"
        :type="type"
        :vto_type="vtoType"
        :vto_category="vtoCategory"
        :vto_upc_list="vtoUpcList"
        :vto_selected_upc="vtoSelectedUpcValue"
        loadingbg="#000"
        loadingmsg="loading"
        switch_ecom="true"
        switch_autostart="true"
      />
    </div>
  </div>
</template>

<script>
  import { loadscript } from '@Foundation/directives/loadscript/loadscript';

  import { eventBus } from '@Foundation/eventbus';

  const MF_SCRIPT = 'modiface-script';

  export default {
    name: 'VtoApp',

    props: {
      scriptUrl: { type: String, required: true },

      tenant: { type: String, required: true },

      application: { type: String, required: true },

      customer: { type: String, required: true },

      country: { type: String, required: true },

      environment: { type: String, required: true },

      touchpoint: { type: String, required: true },

      type: { type: String, required: true },

      vtoType: { type: String, required: true },

      vtoCategory: { type: String, required: true },

      vtoUpcList: { type: String, required: true },

      vtoSelectedUpc: { type: String, required: true },
    },

    data() {
      return {
        modalDisplay: false,

        scriptLoaded: false,

        vtoSelectedUpcLocal: null,
      };
    },

    computed: {
      vtoSelectedUpcValue() {
        return this.vtoSelectedUpcLocal || this.vtoSelectedUpc;
      },
    },

    mounted() {
      window.dsfApp = document.createElement('div');

      window.dsfApp.addEventListener('onReady', e => {
        window.dsfApp.open(e.detail.application);
      });

      eventBus.$on('script.loaded', ({ name }) => this.onScriptLoaded(name));

      eventBus.$on('pdpShadeChange', variant => this.onPdpShadeChange(variant));

      window.initModiface = this.initModiface;

      this.initBus();
    },

    methods: {
      onPdpShadeChange(variant) {
        this.vtoSelectedUpcLocal = variant;
      },

      initBus() {
        eventBus.$once('vto_enter', this.load);

        eventBus.$on('vto_enter', () => this.showModal(true));
      },

      load() {
        loadscript.bind(null, {
          value: MF_SCRIPT,

          url: this.scriptUrl,
        });
      },

      onScriptLoaded(scriptName) {
        if (scriptName === MF_SCRIPT) {
          this.scriptLoaded = true;
        }
      },

      showModal(value) {
        this.modalDisplay = value;
      },

      initModiface() {
        this.showModal(true);
      },
    },
  };
</script>
